__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/891720c9053c79a2154c81f98cb9f3d1b62c5db8c52adf883143b1dd/";